module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/assessment_achievements/2@2x_5cb89b450944337b7848b16a0f94d624.png";